import { render } from "./DashboardSettingsDialog.vue?vue&type=template&id=8e9ee890"
import script from "./DashboardSettingsDialog.vue?vue&type=script&lang=js"
export * from "./DashboardSettingsDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui/components/DashboardSettingsDialog.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8e9ee890"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8e9ee890', __exports__)) {
    api.reload('8e9ee890', __exports__)
  }
  
  module.hot.accept("./DashboardSettingsDialog.vue?vue&type=template&id=8e9ee890", () => {
    api.rerender('8e9ee890', render)
  })

}


export default __exports__